var utils = require('../../utils')
export default {
  name: 'date-picker',
  props: ['value', 'defval'],

  mounted: function () {
    // activate the plugin when the component is mounted.
    $(this.$el).datepicker({
        dateFormat: '和暦',
        defaultDate: this.defaultDate,
        onClose: this.onClose,
        changeMonth: true,
        changeYear: true,
        yearRange: '-120:+5',
        yearSuffix: '',
        wareki2Seireki: this.wareki2Seireki,
        seireki2Wareki: this.seireki2Wareki,
        showOtherMonths: true,
        selectOtherMonths: true
    })
    // モーダル等、"display:none"時の挙動対応
    var onClose = this.onClose
    $(this.$el).off('blur.date-picker')
    $(this.$el).on('blur.date-picker', function() {
      if ($(this).parents('.modal').length > 0) {
        onClose($(this).val())
      }
    })
  },
  computed: {
    defaultDate() {
      return (!!this.defval) ? this.defval : new Date()
    }
  },

  methods: {
    // callback for when the selector popup is closed.
    onClose(date) {
      this.$emit('change', date);
    },
    seireki2Wareki(seireki_str) {
      return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
    },
    wareki2Seireki(wareki_str) {
      return utils.wareki2Seireki(this.$t, wareki_str)
    }
  },
  watch: {
    // when the value fo the input is changed from the parent,
    // the value prop will update, and we pass that updated value to the plugin.
    value(newVal) { $(this.el).datepicker('setDate', newVal); }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/date-picker.js